(() => {
  const swatchExpansionState = new Map();

  const getQuantity = (input) => {
    const value = Number(input?.value || 1);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const updateBuyNowLinks = () => {
    document.querySelectorAll('[data-gt-buy-now-link]').forEach((link) => {
      const productInfo = link.closest('product-info') || document.querySelector('product-info');
      const form = link.closest('form');
      const variantInput = productInfo?.querySelector('.product-variant-id') || form?.querySelector('.product-variant-id');
      const quantityInput = productInfo?.querySelector('.quantity__input') || form?.querySelector('.quantity__input');
      const variantId = variantInput?.value;
      const cartBaseUrl = link.getAttribute('data-cart-base-url') || '/cart';
      const disabled = !variantId || variantInput?.disabled;

      if (variantId) link.href = `${cartBaseUrl}/${variantId}:${getQuantity(quantityInput)}?checkout`;
      link.toggleAttribute('aria-disabled', disabled);
    });
  };

  document.querySelectorAll('[data-gt-favorite]').forEach((button) => {
    const productId = button.getAttribute('data-product-id');
    const storageKey = `gt-favorite-${productId}`;

    try {
      const saved = window.localStorage.getItem(storageKey) === 'true';
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    } catch (error) {
      button.setAttribute('aria-pressed', 'false');
    }

    button.addEventListener('click', () => {
      const nextState = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', nextState ? 'true' : 'false');
      try {
        window.localStorage.setItem(storageKey, nextState ? 'true' : 'false');
      } catch (error) {
        // Some preview/private browsing contexts block localStorage.
      }
    });
  });

  const closeSizeGuideModal = (modal) => {
    modal.hidden = true;
    document.body.classList.remove('gt-size-guide-open');
  };

  const openSizeGuideModal = (modal) => {
    const dialog = modal.querySelector('.gt-size-guide-modal__dialog');
    modal.hidden = false;
    document.body.classList.add('gt-size-guide-open');
    dialog?.focus();
  };

  const getHashTarget = (trigger) => {
    const href = trigger?.getAttribute('href') || '';
    if (!href.startsWith('#')) return null;
    return document.getElementById(href.slice(1)) || document.querySelector(href);
  };

  const setupSizeGuideModals = () => {
    document.querySelectorAll('[data-gt-size-guide-modal]').forEach((modal) => {
      if (modal.dataset.gtSizeGuideInitialized === 'true') return;
      modal.dataset.gtSizeGuideInitialized = 'true';

      modal.querySelectorAll('[data-gt-size-guide-close]').forEach((button) => {
        button.addEventListener('click', () => closeSizeGuideModal(modal));
      });

      modal.querySelectorAll('[data-gt-size-guide-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const panelId = tab.getAttribute('aria-controls');
          modal.querySelectorAll('[data-gt-size-guide-tab]').forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          modal.querySelectorAll('.gt-size-guide-modal__panel').forEach((panel) => {
            panel.hidden = panel.id !== panelId;
          });
        });
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSizeGuideModal(modal);
      });
    });
  };

  setupSizeGuideModals();

  document.addEventListener('click', (event) => {
    const modalTrigger = event.target.closest('[data-gt-size-guide-open]');
    if (modalTrigger) {
      setupSizeGuideModals();
      const modal = getHashTarget(modalTrigger) || document.querySelector('[data-gt-size-guide-modal]');
      if (!modal) return;

      event.preventDefault();
      event.stopPropagation();
      openSizeGuideModal(modal);
      return;
    }

    const detailsTrigger = event.target.closest('.gt-size-guide-link[href^="#ProductDetails-"]');
    if (!detailsTrigger) return;

    const target = getHashTarget(detailsTrigger);
    if (target?.tagName === 'DETAILS') {
      event.preventDefault();
      target.open = true;
    }
  }, true);

  const setupProductDetailsTabs = () => {
    document.querySelectorAll('.gt-product-details').forEach((details) => {
      if (details.dataset.gtTabsInitialized === 'true') return;
      details.dataset.gtTabsInitialized = 'true';

      const tabs = Array.from(details.querySelectorAll('[data-gt-product-details-tab]'));
      const panels = Array.from(details.querySelectorAll('.gt-product-details__panel'));
      if (!tabs.length || !panels.length) return;
      details.open = true;
      details.dataset.collapsed = 'false';

      const setActiveTab = (tab) => {
        const panelId = tab.getAttribute('aria-controls');
        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
          panel.classList.toggle('is-active', panel.id === panelId);
        });
        details.open = true;
        details.dataset.collapsed = 'false';
      };

      setActiveTab(tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0]);

      details.querySelector('.gt-product-details__main-summary')?.addEventListener('click', (event) => {
        event.preventDefault();
        details.open = true;
        details.dataset.collapsed = details.dataset.collapsed === 'true' ? 'false' : 'true';
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActiveTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          const currentIndex = tabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          tabs[nextIndex].focus();
          setActiveTab(tabs[nextIndex]);
        });
      });
    });
  };

  const measureCollapsedSwatches = (group) => {
    const extras = Array.from(group.querySelectorAll('[data-gt-swatch-extra]'));
    const previousDisplay = extras.map((extra) => extra.style.display);

    extras.forEach((extra) => {
      extra.style.display = 'none';
    });

    const height = group.scrollHeight;

    extras.forEach((extra, index) => {
      extra.style.display = previousDisplay[index];
    });

    return height;
  };

  const getSwatchGroupKey = (group) =>
    `${group.dataset.sectionId || 'product'}:${group.dataset.optionName || 'swatches'}`;

  const updateSwatchToggleState = (group, expanded) => {
    const toggle = group.querySelector('[data-gt-swatch-toggle]');
    const toggleText = group.querySelector('[data-gt-swatch-toggle-text]');

    group.dataset.expanded = expanded ? 'true' : 'false';
    group.classList.toggle('is-expanded', expanded);
    toggle?.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (toggleText) {
      toggleText.textContent = expanded ? group.dataset.showLessLabel || 'Show less' : group.dataset.showMoreLabel || 'Show more';
    }
  };

  const setSwatchGroupExpanded = (group, expanded, options = {}) => {
    const animate = options.animate !== false;
    const persist = options.persist !== false;
    const extras = Array.from(group.querySelectorAll('[data-gt-swatch-extra]'));
    const toggle = group.querySelector('[data-gt-swatch-toggle]');
    if (!extras.length || !toggle) return;

    if (persist) swatchExpansionState.set(getSwatchGroupKey(group), expanded);

    if (!animate) {
      extras.forEach((extra) => {
        extra.hidden = !expanded;
      });
      updateSwatchToggleState(group, expanded);
      group.style.maxHeight = '';
      return;
    }

    const startHeight = group.offsetHeight;
    group.classList.add('is-animating');
    group.style.maxHeight = `${startHeight}px`;

    if (expanded) {
      extras.forEach((extra) => {
        extra.hidden = false;
      });
    }

    const endHeight = expanded ? group.scrollHeight : measureCollapsedSwatches(group);
    updateSwatchToggleState(group, expanded);

    window.requestAnimationFrame(() => {
      group.style.maxHeight = `${endHeight}px`;
    });

    const finish = (event) => {
      if (event.target !== group || event.propertyName !== 'max-height') return;
      group.removeEventListener('transitionend', finish);
      group.classList.remove('is-animating');

      if (!expanded) {
        extras.forEach((extra) => {
          extra.hidden = true;
        });
      }

      group.style.maxHeight = '';
    };

    group.addEventListener('transitionend', finish);
  };

  const setupSwatchShowMore = () => {
    document.querySelectorAll('[data-gt-swatch-group]').forEach((group) => {
      const storedExpanded = swatchExpansionState.get(getSwatchGroupKey(group));
      if (typeof storedExpanded === 'boolean') {
        setSwatchGroupExpanded(group, storedExpanded, { animate: false, persist: false });
      }
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-gt-swatch-toggle]');
    if (!toggle) return;

    const group = toggle.closest('[data-gt-swatch-group]');
    if (!group) return;

    event.preventDefault();
    event.stopPropagation();
    setSwatchGroupExpanded(group, group.dataset.expanded !== 'true');
  }, true);

  const setupTeeMockupPreviews = () => {
    document.querySelectorAll('[data-gt-tee-preview]').forEach((preview) => {
      if (preview.dataset.gtInitialized === 'true') return;
      preview.dataset.gtInitialized = 'true';

      const mockup = preview.querySelector('[data-gt-tee-mockup]');
      const variantInput = document.querySelector('product-info .product-variant-id');
      const variantMapScript = preview.querySelector('[data-gt-tee-variant-map]');
      let variants = {};

      try {
        variants = JSON.parse(variantMapScript?.textContent || '{}');
      } catch (error) {
        variants = {};
      }

      const setPreviewVariant = (variantId) => {
        const variant = variants[String(variantId)] || {};

        if (!mockup || !variant.mockup) {
          preview.classList.add('is-missing-mockup');
          return;
        }

        if (mockup.getAttribute('src') !== variant.mockup) {
          mockup.src = variant.mockup;
        }
        mockup.alt = variant.alt || '';
        preview.classList.remove('is-missing-mockup');

        if (variant.aspectRatio) {
          preview
            .querySelector('.gt-tee-preview__stage')
            ?.style.setProperty('--gt-tee-preview-ratio', String(variant.aspectRatio));
        }
      };

      setPreviewVariant(preview.dataset.currentVariantId || variantInput?.value);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const variantId = data?.variant?.id || variantInput?.value;
          setPreviewVariant(variantId);
        });
      }

      document.addEventListener('change', (event) => {
        if (event.target?.matches?.('.product-variant-id')) {
          window.requestAnimationFrame(() => setPreviewVariant(event.target.value));
        }
      });
    });
  };

  const getMainProductForm = () =>
    document.querySelector('product-info form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[data-type="add-to-cart-form"]');

  const setupPersonalizationBoxes = () => {
    const boxes = Array.from(document.querySelectorAll('[data-gt-personalization]'));
    if (!boxes.length) return;

    const mainForm = getMainProductForm();
    if (!mainForm) return;

    if (!mainForm.id) mainForm.id = `gt-product-form-${Date.now()}`;

    const getHiddenInput = (box) => {
      let hidden = Array.from(mainForm.querySelectorAll('[data-gt-personalization-hidden]')).find(
        (input) => input.dataset.gtPersonalizationHidden === box.id
      );

      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.dataset.gtPersonalizationHidden = box.id;
        mainForm.appendChild(hidden);
      }

      hidden.name = `properties[${box.dataset.propertyName || 'Personalization'}]`;
      return hidden;
    };

    const updateBox = (box) => {
      const textarea = box.querySelector('[data-gt-personalization-input]');
      const counter = box.querySelector('[data-gt-personalization-count]');
      const hidden = getHiddenInput(box);
      const value = textarea?.value || '';
      const hasValue = value.trim().length > 0;
      const isRequired = box.dataset.required === 'true';

      hidden.value = value;
      hidden.disabled = !isRequired && !hasValue;
      if (counter) counter.textContent = String(value.length);

      if (hasValue || !isRequired) {
        textarea?.setAttribute('aria-invalid', 'false');
        const error = box.querySelector('[data-gt-personalization-error]');
        if (error) error.hidden = true;
      }
    };

    const validateBoxes = () => {
      let firstInvalid = null;

      boxes.forEach((box) => {
        const textarea = box.querySelector('[data-gt-personalization-input]');
        const error = box.querySelector('[data-gt-personalization-error]');
        const isRequired = box.dataset.required === 'true';
        const isInvalid = isRequired && !(textarea?.value || '').trim();

        updateBox(box);
        textarea?.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
        if (error) error.hidden = !isInvalid;
        if (isInvalid && !firstInvalid) firstInvalid = textarea;
      });

      if (firstInvalid) {
        firstInvalid.closest('details')?.setAttribute('open', '');
        firstInvalid.focus();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      return true;
    };

    boxes.forEach((box) => {
      if (box.dataset.gtPersonalizationReady === 'true') {
        updateBox(box);
        return;
      }

      box.dataset.gtPersonalizationReady = 'true';
      const textarea = box.querySelector('[data-gt-personalization-input]');
      textarea?.addEventListener('input', () => updateBox(box));
      updateBox(box);
    });

    if (mainForm.dataset.gtPersonalizationValidationReady !== 'true') {
      mainForm.dataset.gtPersonalizationValidationReady = 'true';
      mainForm.addEventListener(
        'submit',
        (event) => {
          if (!validateBoxes()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    }

    document.querySelectorAll('[data-gt-buy-now-link]').forEach((link) => {
      if (link.dataset.gtPersonalizationBuyNowReady === 'true') return;
      link.dataset.gtPersonalizationBuyNowReady = 'true';

      link.addEventListener('click', async (event) => {
        const hasPersonalization = boxes.some((box) => {
          const value = box.querySelector('[data-gt-personalization-input]')?.value || '';
          return box.dataset.required === 'true' || value.trim().length > 0;
        });

        if (!hasPersonalization) return;

        event.preventDefault();
        if (!validateBoxes() || link.getAttribute('aria-disabled') === 'true') return;

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: new FormData(mainForm),
          });

          if (!response.ok) throw new Error('Unable to add personalized item');
          window.location.href = window.routes?.checkout_url || '/checkout';
        } catch (error) {
          mainForm.requestSubmit?.();
        }
      });
    });
  };

  const formatMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const setupStickyAddToCart = () => {
    document.querySelectorAll('[data-gt-sticky-atc]').forEach((sticky) => {
      const productInfo = document.querySelector('product-info');
      const mainForm = productInfo?.querySelector('form[data-type="add-to-cart-form"]');
      const mainSubmit = mainForm?.querySelector('[type="submit"][name="add"]');
      const mainQuantity = productInfo?.querySelector('.quantity__input[name="quantity"]');
      const stickyQuantity = sticky.querySelector('[data-gt-sticky-quantity]');
      const stickySubmit = sticky.querySelector('[data-gt-sticky-submit]');
      const title = sticky.querySelector('[data-gt-sticky-variant-title]');
      const titleSeparator = sticky.querySelector('.gt-sticky-atc__meta-separator');
      const price = sticky.querySelector('[data-gt-sticky-current-price]');
      const buttonPrice = sticky.querySelector('[data-gt-sticky-button-price]');
      const image = sticky.querySelector('[data-gt-sticky-image]');
      const message = sticky.querySelector('[data-gt-free-shipping-message]');
      const progress = sticky.querySelector('[data-gt-free-shipping-progress]');
      const variantsScript = sticky.querySelector('[data-gt-sticky-variants]');
      let variants = {};
      let cartRefreshTimer;

      if (!mainForm || !mainSubmit || !stickySubmit) return;

      try {
        variants = JSON.parse(variantsScript?.textContent || '{}');
      } catch (error) {
        variants = {};
      }

      const currentVariantId = () => productInfo?.querySelector('.product-variant-id')?.value;
      const currentVariant = () => variants[currentVariantId()] || {};
      const setCartTotal = (total) => {
        const nextTotal = Number(total);
        if (Number.isFinite(nextTotal)) sticky.dataset.cartTotal = String(nextTotal);
      };

      const syncStickyQuantityFromMain = () => {
        if (!mainQuantity || !stickyQuantity) return;
        if (stickyQuantity.value !== mainQuantity.value) stickyQuantity.value = mainQuantity.value;
      };

      const refreshCartTotal = async () => {
        const cartUrl = `${window.routes?.cart_url || '/cart'}.js`;

        try {
          const response = await fetch(cartUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;

          const cart = await response.json();
          setCartTotal(cart.total_price);
          updateFreeShipping();
        } catch (error) {
          // Keep the server-rendered cart total if the AJAX cart endpoint is blocked.
        }
      };

      const scheduleCartRefresh = () => {
        window.clearTimeout(cartRefreshTimer);
        cartRefreshTimer = window.setTimeout(refreshCartTotal, 250);
      };

      const updateFreeShipping = () => {
        if (!message) return;

        const threshold = Number(sticky.dataset.freeShippingThreshold || 0);
        const cartTotal = Number(sticky.dataset.cartTotal || 0);
        const countSelectedProduct = sticky.dataset.countSelectedProduct === 'true';
        const variant = currentVariant();
        const quantity = getQuantity(stickyQuantity || mainQuantity);
        const lineTotal = countSelectedProduct ? Number(variant.price_cents || 0) * quantity : 0;
        const remaining = Math.max(0, threshold - cartTotal - lineTotal);

        if (threshold <= 0 || remaining <= 0) {
          message.textContent = sticky.dataset.freeShippingReachedText || '';
        } else {
          message.textContent = (sticky.dataset.freeShippingTemplate || '').replace(
            '[amount]',
            formatMoney(remaining, sticky.dataset.currency)
          );
        }

        if (progress && threshold > 0) {
          const percent = Math.min(100, Math.max(0, ((cartTotal + lineTotal) / threshold) * 100));
          progress.style.setProperty('--gt-progress', `${percent}%`);
        }
      };

      const updateVariant = () => {
        const variant = currentVariant();
        const variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';

        if (title) title.textContent = variantTitle;
        if (titleSeparator) titleSeparator.hidden = !variantTitle;
        if (price && variant.price) price.textContent = variant.price;
        if (buttonPrice && variant.price) buttonPrice.textContent = `\u00b7 ${variant.price}`;
        if (image && variant.image) image.src = variant.image;
        if (stickySubmit) stickySubmit.disabled = mainSubmit.disabled || variant.available === false;

        updateFreeShipping();
      };

      const setStickyVisibility = () => {
        const rect = mainSubmit.getBoundingClientRect();
        const isVisible = rect.bottom < 0;
        sticky.classList.toggle('is-visible', isVisible);
        document.body.classList.toggle('gt-sticky-atc-active', isVisible);
      };

      stickySubmit.addEventListener('click', (event) => {
        event.preventDefault();
        if (stickySubmit.disabled || mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true') return;

        if (mainQuantity && stickyQuantity) {
          mainQuantity.value = getQuantity(stickyQuantity);
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }

        mainSubmit.click();
      });

      stickyQuantity?.addEventListener('input', updateFreeShipping);
      stickyQuantity?.addEventListener('change', updateFreeShipping);
      mainQuantity?.addEventListener('change', () => {
        syncStickyQuantityFromMain();
        updateFreeShipping();
      });

      window.addEventListener('scroll', setStickyVisibility, { passive: true });
      window.addEventListener('resize', setStickyVisibility);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          window.requestAnimationFrame(() => {
            syncStickyQuantityFromMain();
            updateVariant();
          });
        });

        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          scheduleCartRefresh();
        });
      }

      syncStickyQuantityFromMain();
      refreshCartTotal();
      updateVariant();
      setStickyVisibility();
    });
  };

  setupStickyAddToCart();
  setupProductDetailsTabs();
  setupSwatchShowMore();
  setupTeeMockupPreviews();
  setupPersonalizationBoxes();
  updateBuyNowLinks();

  document.addEventListener('input', (event) => {
    if (event.target?.matches?.('.quantity__input')) updateBuyNowLinks();
  });

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('.quantity__input, .product-variant-id')) updateBuyNowLinks();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, updateBuyNowLinks);
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.requestAnimationFrame(setupSwatchShowMore);
    });
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      window.requestAnimationFrame(setupPersonalizationBoxes);
    });
  }
})();
